import { useState } from "react";
import {
  Button,
  Box,
  TextField,
  Autocomplete,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseUserPollManagment } from "./UseUserPollManagment";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { useSnackbar } from "notistack";

export default function AddPoll() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { validate, AddUserPoll } = UseUserPollManagment();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const orderType = [
    { id: 1, value: "پیک موتوری" },
    { id: 2, value: "پست" },
  ];

  const [state, setState] = useState({
    id: undefined,
    rowIndex: undefined,
    question: undefined,
    answer1: undefined,
    answer2: undefined,
    answer3: undefined,
    answer4: undefined,
    answer5: undefined,
    orderType: undefined,
    hasGraid: false,
    hasDescribe: false,
    isActive: true,
  });

  const [errorState, setErrorState] = useState({
    orderType: false,
    question: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/userpollmanagment" },
          { name: "نظرسنجی جدید", url: "/userpollmanagment/addPoll" },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn="span 6">
            <TextField
              fullWidth
              value={state.question ? state.question : ""}
              error={errorState.question}
              label="سوال"
              size="small"
              multiline
              maxRows={5}
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, question: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box gridColumn="span 6"></Box>
          <Box gridColumn="span 3">
            <Autocomplete
              size="small"
              value={state.orderType ? state.orderType : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setState({ ...state, orderType: newValue });
                } else {
                  setState({ ...state, orderType: undefined });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return orderType?.find((m) => m.id == option).value;
                }
                return "";
              }}
              fullWidth
              options={orderType.map((m) => m.id)}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  error={errorState.orderType}
                  label="نوع ارسال"
                />
              )}
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box gridColumn="span 3">
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.answer1 ? state.answer1 : ""}
              label="پاسخ 1 "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, answer1: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box gridColumn="span 3">
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.answer2 ? state.answer2 : ""}
              label="پاسخ 2 "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, answer2: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box gridColumn="span 3">
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.answer3 ? state.answer3 : ""}
              label="پاسخ 3 "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, answer3: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box gridColumn="span 3">
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.answer4 ? state.answer4 : ""}
              label="پاسخ 4 "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, answer4: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box gridColumn="span 3">
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.answer5 ? state.answer5 : ""}
              label="پاسخ 5 "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, answer5: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box gridColumn="span 3">
            <FormControlLabel
              checked={state.isActive ? state.isActive : false}
              onChange={(evt) => {
                setState({ ...state, isActive: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فعال"
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box gridColumn="span 3">
            <FormControlLabel
              checked={state.hasGraid ? state.hasGraid : false}
              onChange={(evt) => {
                setState({ ...state, hasGraid: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="رتبه دارد"
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box gridColumn="span 3">
            <FormControlLabel
              checked={state.hasDescribe ? state.hasDescribe : false}
              onChange={(evt) => {
                setState({ ...state, hasDescribe: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="شرح دارد"
            />
          </Box>
          <Box gridColumn="span 9"></Box>
          <Box
            gridColumn="span 6"
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  AddUserPoll(state, () => {
                    navigate("/userpollmanagment", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/userpollmanagment", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
